
import Restaurants from "../components/Restaurants" // Assure-toi que ce fichier existe
import Footer from "../components/Footer"
import Header from "../components/Header"

function restaurants() {
  return (
    <>
      <Header />
      <Restaurants />
      <Footer />
    </>
  )
}

export default restaurants
